import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { populateXYNormalize, formatTimeSeriesData } from "utils/reportUtils";
import { notAllZeros } from "utils/utils";
import PlotlyReport from "./PlotlyReport";
import { valueStrings } from "constants/constantStrings";

const NormalizeSeriesChart = ({ report, intialLayout, data, error, isLoading, width, setError }) => {
  const [layout] = useState({ ...intialLayout });
  const [chartData, setChartData] = useState(null);
  const { tagsAsObj } = useSelector(state => state.tags);

  useEffect(() => {
    if (data && data.Data) {
      const traceData = [];
      const widgetData = { ...data, Tags: Object.values(tagsAsObj) };
      const processData = formatTimeSeriesData(widgetData);
      let count = 1;
      if (processData["Yaxis"] && processData.Time?.length !== 0) {
        for (let tag = 0; tag < processData["Yaxis"].length; tag++) {
          if (notAllZeros(processData["Yaxis"][tag]) && processData["Yaxis"][tag].Values?.length > 0) {
            traceData.push(populateXYNormalize(processData.Time, processData["Yaxis"][tag], "scattergl", count));
            count++;
          }
        }
        setChartData(traceData);
      } else {
        report.error = valueStrings.noData;
        setError(valueStrings.noData);
      }
    }
  }, [data]);

  return (
    <PlotlyReport
      report={report}
      chartData={chartData}
      layout={layout}
      isLoading={isLoading}
      error={error}
      setChartData={setChartData}
      width={width}
    />
  );
};

export default NormalizeSeriesChart;
